const SHORT_HEX = /^#([0-9a-f])([0-9a-f])([0-9a-f])$/i;
const LONG_HEX = /^#[0-9a-f]{6}$/i;

/** `<input type="color">` accepts nothing but lower-case #rrggbb. */
export function toPickerHex(value: string): string {
  const text = value.trim();
  if (LONG_HEX.test(text)) return text.toLowerCase();
  const short = SHORT_HEX.exec(text);
  if (short) {
    return `#${short[1]}${short[1]}${short[2]}${short[2]}${short[3]}${short[3]}`.toLowerCase();
  }
  return '#000000';
}
